import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { EventsDesktopView } from '../views/EventsDesktopView';
import { EventsMobileView } from '../views/EventsMobileView';
import { EventsTabletView } from '../views/EventsTabletView';

export function EventsPage() {
  const device = useDeviceClass();
  if (device === 'mobile') return <EventsMobileView />;
  if (device === 'tablet') return <EventsTabletView />;
  return <EventsDesktopView />;
}
